module.exports = __webpack_public_path__ + "media/images/flags/kz-781fbde8446f8cd786f72ae6c15ab4a9.svg";